import api from "../../../../api";
import { env } from '../../../../env';

const baseurl = env.REACT_APP_API_URL_VASKE;

class RegisterClient {
  async Register(isBackground) {
    try {
      var response = await api.get(baseurl + "/Register", {isBackground: isBackground});
      return response.data;
    }
    catch (err) {
      if (err.response.status === 400) return err.response.data;
      else return err.response;
    }
  }

  async GetAllActiveRegisters(isBackground) {
    try {
      var response = await api.get(baseurl + "/Register/GetAcitveRegisters", {isBackground: isBackground});
      return response.data;
    }
    catch (err) {
      if (err.response.status === 400) return err.response.data;
      else return err.response;
    }
  }

  async CreateRegister(data, isBackground) {
    try {
      var response = await api.post(baseurl + "/Register", data, {isBackground: isBackground});
      return response.data;
    }
    catch (err) {
      if (err.response.status === 400) return err.response.data;
      else return err.response;
    }
  }

  async UpdateRegister(id, data, isBackground) {
    try {
      var response = await api.put(baseurl + "/Register/" + id, data, {isBackground: isBackground});
      return response.data;
    }
    catch (err) {
      if (err.response.status === 400) return err.response.data;
      else return err.response;
    }
  }
  async DeleteRegister(id, isBackground) {
    try {
      var response = await api.delete(baseurl + "/Register?id=" + id, {isBackground: isBackground});
      return response.data;
    } catch (err) {
      if (err.response.status === 400) return err.response.data;
      else return err.response;
    }
  }
}

export default RegisterClient;
